// BVNK Currency Schema
export interface BvnkCurrency {
  name: string
  code: string
  icon: string
  enabled: boolean
  allowDeposit: boolean
  allowWithdrawal: boolean
  decimalPrecision: number
  displayPrecision: number
  pricePrecision: number
  ranking: number
  enabledProtocols: Protocol[]
  currencyOptions: Options
  fiat: boolean
  stableCoin: boolean
}

// Layer1 Currency Schema
export interface Layer1Currency {
  code: string
  name: string
  network: string
  icon: string | null
  decimalPrecision: number
  displayPrecision: number
  depositEnabled: boolean
  withdrawalEnabled: boolean
  crypto: boolean
}

// Union type to support both schemas
export type Currency = BvnkCurrency | Layer1Currency

// Type guards to distinguish between schemas
export const isBvnkCurrency = (currency: Currency): currency is BvnkCurrency => {
  return 'enabledProtocols' in currency
}

export const isLayer1Currency = (currency: Currency): currency is Layer1Currency => {
  return 'network' in currency && !('enabledProtocols' in currency)
}

export interface CurrencyOption {
  code: string
  protocols: string[]
}

export interface Options {
  transaction: string
  address: string
  confirmations: number
  explorer: string
}

export interface Protocol {
  code: string
  network: string
}

export enum CurrencyCode {
  USDT = 'USDT',
  USDC = 'USDC',
  ETH = 'ETH',
  XRP = 'XRP',
  ALGO = 'ALGO',
}

export enum ProtocolCode {
  ERC20 = 'erc20',
  POLYGON = 'polygon',
}

export enum DestinationTag {
  Required = 'DestinationTagRequired',
  NotRequired = 'DestinationTagNotRequired',
  Empty = '',
}
